const GEOTAG = [
  { label: 'Exact location', value: 'exact location' },
  { label: 'Near here', value: 'Near here' },
  { label: 'In this town/city', value: 'In this town/city' },
  { label: 'In this country', value: 'In this country' },
];

export { GEOTAG };
